import { Link } from "@tanstack/react-router";
import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/lib/utils";

const goldClasses =
  "t-button inline-flex h-[var(--gold-button-height)] items-center justify-center rounded-medium px-[28px] text-gold-on " +
  "bg-[linear-gradient(var(--gold-angle),var(--gold-from)_0%,var(--gold-to)_71.4%)] " +
  "transition-shadow transition-colors duration-200 " +
  "hover:bg-[linear-gradient(var(--gold-angle),var(--gold-hover-from)_0%,var(--gold-hover-to)_71.4%)] " +
  "hover:shadow-gold " +
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-to " +
  "disabled:opacity-60 disabled:pointer-events-none";

type GoldButtonVariant = { variant?: "default" | "service" };

type GoldButtonProps =
  | ({ as?: "button" } & ComponentProps<"button"> & GoldButtonVariant)
  | ({ as: "a" } & ComponentProps<"a"> & GoldButtonVariant)
  | ({ as: "link" } & ComponentProps<typeof Link> & GoldButtonVariant);

export function GoldButton(props: GoldButtonProps & { children?: ReactNode }) {
  const variantClass = props.variant === "service" ? "gold-button-service" : undefined;
  if (props.as === "link") {
    const { as: _as, variant: _variant, className, ...rest } = props;
    return <Link {...rest} className={cn(goldClasses, variantClass, className)} />;
  }

  if (props.as === "a") {
    const { as: _as, variant: _variant, className, ...rest } = props;
    return <a {...rest} className={cn(goldClasses, variantClass, className)} />;
  }

  const { as: _as, variant: _variant, className, type, ...rest } = props as ComponentProps<"button"> & GoldButtonVariant & {
    as?: "button";
  };
  return <button type={type ?? "button"} {...rest} className={cn(goldClasses, variantClass, className)} />;
}

export default GoldButton;
